import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledSidebarPanelButton,
  StyledSidebarPanelButtonLabel,
} from './SidebarPanelButton.styled';

const SidebarPanelButton = ({
  Icon,
  label,
  lead = null,
  onClick,
  onKeyDown,
  disabled = false,
  className = '',
  title,
  children = null,
  'aria-selected': ariaSelected,
}) => {
  const accessibleName = title || label;
  const isInteractive = Boolean(onClick) && !disabled;

  return (
    <StyledSidebarPanelButton
      className={`respark_sidebar-panel-row-btn${className ? ` ${className}` : ''}${disabled ? ' respark_sidebar-panel-row-btn--disabled' : ''}`}
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      aria-label={accessibleName || undefined}
      aria-disabled={disabled || undefined}
      aria-selected={ariaSelected}
      title={accessibleName || undefined}
      onClick={isInteractive ? onClick : undefined}
      onKeyDown={isInteractive ? onKeyDown : undefined}
    >
      {lead || (Icon ? <Icon size={18} /> : null)}
      {label ? (
        <StyledSidebarPanelButtonLabel className="respark_sidebar-panel-row-btn__label">
          {label}
        </StyledSidebarPanelButtonLabel>
      ) : null}
      {children}
    </StyledSidebarPanelButton>
  );
};

SidebarPanelButton.propTypes = {
  Icon: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.instanceOf(Object),
  ]),
  lead: PropTypes.node,
  label: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  'aria-selected': PropTypes.bool,
};

export default SidebarPanelButton;
